var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13.5416C15.875 13.5416 13.5417 15.875 13.5417 18.75C13.5417 21.625 15.875 23.9583 18.75 23.9583C21.625 23.9583 23.9583 21.625 23.9583 18.75C23.9583 15.875 21.625 13.5416 18.75 13.5416ZM21.875 19.2708H19.2708V21.875H18.2292V19.2708H15.625V18.2291H18.2292V15.625H19.2708V18.2291H21.875V19.2708Z",
    fill: "#DCDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1771 15.625C12.5521 14.8437 13.0521 14.1354 13.6667 13.5416H7.29167V11.4583H18.75C19.8646 11.4583 20.9271 11.7187 21.875 12.177V5.20829C21.875 4.06246 20.9375 3.12496 19.7917 3.12496H15.4375C15 1.91663 13.8542 1.04163 12.5 1.04163C11.1458 1.04163 10 1.91663 9.5625 3.12496H5.20833C4.0625 3.12496 3.125 4.06246 3.125 5.20829V19.7916C3.125 20.9375 4.0625 21.875 5.20833 21.875H12.1771C11.7187 20.927 11.4583 19.8645 11.4583 18.75C11.4583 18.3958 11.4896 18.052 11.5417 17.7083H7.29167V15.625H12.1771ZM12.5 2.86454C12.9271 2.86454 13.2812 3.21871 13.2812 3.64579C13.2812 4.07288 12.9271 4.42704 12.5 4.42704C12.0729 4.42704 11.7188 4.07288 11.7188 3.64579C11.7188 3.21871 12.0729 2.86454 12.5 2.86454ZM7.29167 7.29163H17.7083V9.37496H7.29167V7.29163Z",
    fill: "#DCDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.5ac9990b24ae5b1ac183601769e9af5c.svg";
export { ForwardRef as ReactComponent };